import GenericDB from './generic-db'

export default class ShareLinksDB extends GenericDB {
  constructor() {
    super(`shareLinks`)
  }
  // Here you can extend ShareLinksDB with custom methods
}
